import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Crown, Play } from "lucide-react";
import { GameMetadata } from "@/pages/subs/play/common/game-registry";

export const RoomHostMenu = ({
  game,
  canStartGame,
  handleStartGame,
}: {
  game: GameMetadata;
  canStartGame: boolean;
  handleStartGame: () => void;
}) => {
  return (
    <Card className="mt-4">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Crown className="w-5 h-5 text-yellow-500" />
          방장 메뉴
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Button
          onClick={handleStartGame}
          disabled={!canStartGame}
          className="w-full"
        >
          <Play className="w-4 h-4 mr-2" />
          게임 시작
        </Button>
        {!canStartGame && (
          <p className="text-xs text-muted-foreground mt-2 text-center">
            최소 {game?.minPlayers || 2}명의 플레이어가 필요합니다
          </p>
        )}
      </CardContent>
    </Card>
  );
};
